import React from 'react'
import { t } from '@lingui/macro'

import { PrimaryButton, SecondaryButton } from 'components/Buttons'
import { i18n } from 'utils/i18n'

import { root, content, text, button } from './placeholder.module.scss'

interface Props {
  aspectRatio: number
}

const Placeholder = ({ aspectRatio }: Props) => {
  const openCookieSettings = () => {
    if (window.OneTrust) {
      window.OneTrust.ToggleInfoDisplay()
    }
  }

  const allowAllCookies = () => {
    if (window.OneTrust) {
      window.OneTrust.AllowAll()
    }
  }

  return (
    <div className={root}>
      <div style={{ paddingTop: `${100 / aspectRatio}%` }} />
      <div className={content}>
        <p className={text}>
          {i18n._(
            t(
              'cookies.embedded_content_placeholder.text'
            )`The embedded content cannot be displayed until consent to the required cookies is allowed.`
          )}
        </p>
        <div>
          <SecondaryButton
            text={i18n._(
              t(
                'cookies.embedded_content_placeholder.button.open_settings'
              )`Cookie Settings`
            )}
            onClick={openCookieSettings}
            className={button}
          />
          <PrimaryButton
            text={i18n._(
              t(
                'cookies.embedded_content_placeholder.button.allow_all'
              )`Allow All`
            )}
            onClick={allowAllCookies}
            className={button}
          />
        </div>
      </div>
    </div>
  )
}

export default Placeholder
